export const isStaging = process.env.NEXT_PUBLIC_ENV !== 'production';

// 判断是否为 iOS 设备（iPhone/iPad/iPod）
export const isIOS = () => {
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(ua) || (/Mac OS X/i.test(ua) && /Mobile/i.test(ua));
};

// 判断是否为 macOS 桌面系统
export const isMacOS = () => {
  const ua = navigator.userAgent;
  return /Mac OS X/i.test(ua) && !/Mobile/i.test(ua);
};

// 合并判断是否为 Apple 设备（iOS 或 macOS）
export const isAppleDevice = () => {
  return isIOS() || isMacOS();
};
